export class Client {
    
    id: number;
    nit: string;
    name: string;
    phone: string;
    email: string;
    status: string;
    createdAt: string;
    updatedAt: string;
}